export interface IUrlsPaths {
	currentPath: string;
	previousPath: string;
	state?: unknown;
}

export const presetRoutePath: IUrlsPaths[] = [
	{
		currentPath: '/lead/basic-details',
		previousPath: '/leads',
	},
	{
		currentPath: '/lead/more-details',
		previousPath: '/leads',
	},
	{
		currentPath: '/end-user/basic-details',
		previousPath: '/contractor',
	},
	{
		currentPath: '/end-user/more-details',
		previousPath: '/contractor',
	},
	{
		currentPath: '/contractor',
		previousPath: '/end-users',
	},
	{
		currentPath: '/contractor/competition-details',
		previousPath: '/contractor',
	},
	{
		currentPath: '/contractor/qr-code-scanner',
		previousPath: '/contractor',
		state: '',
	},
	{
		currentPath: '/contractor/qr-code-check',
		previousPath: '/contractor',
		state: '',
	},
	{
		currentPath: '/contractor/banking-history',
		previousPath: '/contractor',
		state: '',
	},
	{
		currentPath: '/kyc-verification',
		previousPath: '/contractor',
	},
	{
		currentPath: '/bank-details',
		previousPath: '/contractor',
	},
	{
		currentPath: '/identity-verification/upload-document',
		previousPath: '/contractor',
	},
	{
		currentPath: '/identity-verification/selfie-verification',
		previousPath: '/contractor',
	},
	{
		currentPath: '/meeting/meeting-details',
		previousPath: '/meetings',
		state: '',
	},
	{
		currentPath: '/meeting/meeting-participants',
		previousPath: '/meetings',
		state: '',
	},
	{
		currentPath: '/meeting-details',
		previousPath: '/meetings',
		state: '',
	},
	{
		currentPath: '/today-meetings',
		previousPath: '/meetings/todays-meetings',
		state: '',
	},
	{
		currentPath: '/send-feedback',
		previousPath: '/meetings/all-meetings',
		state: '',
	},
	{
		currentPath: '/send-expense-details',
		previousPath: '/meetings/all-meetings',
		state: '',
	},
	{
		currentPath: '/complete-meeting',
		previousPath: '/meetings/all-meetings',
		state: '',
	},
	{
		currentPath: '/complete-meeting-details',
		previousPath: '/meetings/all-meetings',
		state: '',
	},
	{
		currentPath: '/dfcc-clubs/club-details',
		previousPath: '/dfcc-clubs',
		state: '',
	},
	{
		currentPath: '/site-details-rr',
		previousPath: '/sites',
	},
	{
		currentPath: '/add-new-site/basic',
		previousPath: '/prospective-site',
	},
	{
		currentPath: '/add-new-site/surface',
		previousPath: '/add-new-site/basic',
	},
	{
		currentPath: '/product-sampling-list/raincoat-preview',
		previousPath: '/site-details-rr',
	},
	{
		currentPath: '/product-sampling-list',
		previousPath: '/site-details-rr',
	},
	{
		currentPath: '/one-to-one-meeting/edit',
		previousPath: '/one-to-one-meeting',
	},
];

export const resyncRoutePath: string[] = [
	'/end-users',
	'/leads',
	'/meetings',
	'/meetings/todays-meetings',
	'/meetings/all-meetings',
	'/one-to-one-meeting',
	'/user-transfer/request',
	'/user-transfer/approved',
	'/user-transfer/rejected',
	'/calendar',
	'/dfcc-clubs',
	'/sites',
	'/prospective-site',
];

export const dashboardRedirectPaths: string[] = [
	'/jharokha',
	'/end-users',
	'/leads',
	'/meetings',
	'/meetings/todays-meetings',
	'/meetings/all-meetings',
	'/pcms',
	'/profile',
	'/help-and-support',
	'/one-to-one-meeting',
	'/user-transfer/request',
	'/user-transfer/approved',
	'/user-transfer/rejected',
	'/case-module',
	'/dfcc-clubs',
	'/prospective-site',
	'/sites',
	'/dashboard-detailed-summary/month',
	'/dashboard-detailed-summary/quarter',
	'/dashboard-detailed-summary/year',
	'/feedback-questionnaires',
];
